import { render, staticRenderFns } from "./ReportsAging.vue?vue&type=template&id=2518d2c9&scoped=true&"
import script from "./ReportsAging.vue?vue&type=script&lang=js&"
export * from "./ReportsAging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518d2c9",
  null
  
)

export default component.exports